export const isUserLoggedIn = (token, auth) => {
  const isLoggedOnKaecher = !!auth.user;
  const isLoggedOnCognito = !!token;
  return isLoggedOnKaecher && isLoggedOnCognito;
};
